import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.125 8.266a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.5 6.016a2.25 2.25 0 0 1 2.25-2.25h16.5a2.25 2.25 0 0 1 2.25 2.25v12a2.25 2.25 0 0 1-2.25 2.25H3.75a2.25 2.25 0 0 1-2.25-2.25zM3 16.076v1.94c0 .414.336.75.75.75h16.5a.75.75 0 0 0 .75-.75v-1.94l-2.69-2.689a1.5 1.5 0 0 0-2.12 0l-.88.88.97.969a.75.75 0 1 1-1.06 1.06l-5.16-5.159a1.5 1.5 0 0 0-2.12 0zm11.25-2.87-3.129-3.13a3 3 0 0 0-4.242 0L3 13.957v-7.94a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 .75.75v7.94l-1.629-1.63a3 3 0 0 0-4.242 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }